export const options = [
  { label: 'Open Call', path: '/open-call', completed: false },
  { label: 'Proposal', path: '/proposal', completed: false },
  { label: 'Agreement', path: '/agreement', completed: false },
  { label: 'Design Files', path: '/files', completed: false },
];
